"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var DEFAULT_SORT_VALUE = ['id', 'asc'];
function Filters(_a) {
    var _b, _c;
    var children = _a.children, params = _a.params, setParams = _a.setParams;
    var _d = (_c = (_b = params === null || params === void 0 ? void 0 : params.sort) === null || _b === void 0 ? void 0 : _b.split(' ')) !== null && _c !== void 0 ? _c : DEFAULT_SORT_VALUE, field = _d[0], direction = _d[1];
    var isAsc = direction === 'asc';
    return react_1.default.createElement("div", { className: 'storybook-lists-filters' },
        children,
        params && setParams && react_1.default.createElement(index_1.Buttons.Button, { onClick: function () {
                return setParams(__assign(__assign({}, params), { page: 1, sort: isAsc ? field + " desc" : field + " asc" }));
            }, icon: isAsc ? 'arrow-down' : 'arrow-up', type: 'light', outline: true }));
}
exports.default = Filters;
